import { render } from "./ByWordCloud.vue?vue&type=template&id=79d9af74"
import script from "./ByWordCloud.vue?vue&type=script&lang=js"
export * from "./ByWordCloud.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__